<template>
  <div class="bg" v-show="show">
    <div v-show="showSelect" class="wrapper">
      <div class="headline">
        <p>音频剪辑</p>
        <img src="@assets/img/interview/close.svg" alt="close" class="close" @click="cancel()">
      </div>
      <div class="types">
        <!-- <div :class="{'type': true, 'active': type.code == t.code}" v-for="(t, i) in types" :key="i" @click="selectType(t)" v-show="t.title">
          <img class="selector" :src="type.code == t.code ? selectIcons.active : selectIcons.normal" alt="icon">
          <div class="con">
            <img :src="t.code == type.code ? t.icons.active : t.icons.normal" alt="icon">
            <p>{{t.title}}</p>
          </div>
        </div> -->
        <div :class="{'type': true, 'active': type.code == t.code}" v-for="(t, i) in types" :key="i" @click="selectType(t)" v-show="t.title">
          <img class="selector" :src="type.code == t.code ? selectIcons.active : selectIcons.normal" alt="icon">
          <div class="con">
            <img :src="t.code == type.code ? t.icons.active : t.icons.normal" alt="icon">
            <p>{{t.title}}</p>
          </div>
        </div>
      </div>
      <div v-if="showNoticeDetail" class="notice-container">
        <div v-if="type.code==0" class="smartEdit">
          <div>
            <img src="@assets/img/common/voiceNotice.svg">
            <p>智能剪辑必须先转文字</p>
          </div>
        </div>
        <div v-if="type.code==1" class="peEdit">
          <div>
            <img src="@assets/img/common/voiceNotice.svg">
            <p>PE编辑请先安装同步客户端</p>
          </div>
          <div>
            <p>还没有软件？</p>
            <a @click="goPeMiddle">点击下载</a>
          </div>
        </div>
      </div>
      <div class="btns">
        <!-- <p class="confirm green" @click="confirm()">下一步</p> -->
        <p class="btn" @click="confirm" :class="{'green': canSubmit}">确定</p>
        <p class="btn" @click="close">取消</p>
      </div>
    </div>
    <div v-show="showDownload" class="download-container">
      <span class="text">音频下载中请勿关闭页面</span>
      <img src="@assets/img/interview/close.svg" alt="close" class="close" @click="cancel()">
      <div class="line">
        <p :style="'width:'+downloadPercent" class="green"></p>
      </div>
    </div>
    <div v-show="showNotice" class="important-container">
        <div class="importantIcon">
          <img src="@assets/img/common/noticeIcon.svg" alt="importantNotice">
        </div>
        <img src="@assets/img/interview/close.svg" alt="close" class="close" @click="cancel()">
        <p>重要提示</p>
        <span>音频正在剪辑制作中，请不要关闭文稿编辑界面</span>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis,websocketjs,peMiddle} from '@common/config'
import script from '../script'

export default {
  name: 'confirm',
  data() {
    return {
      show: true,
      selectIcons:{
        normal: require('@assets/img/common/selectIcon.svg'),
        active: require('@assets/img/common/selectIconOn.svg')
      },
      types: [
        {
          icons:{
            normal: require('@assets/img/common/smartEdit.svg'),
            active: require('@assets/img/common/smartEditOn.svg')
          },
          code: 0,
          title: ''
        },
        {
          icons:{
            normal: require('@assets/img/common/peEdit.svg'),
            active: require('@assets/img/common/peEditOn.svg')
          },
          code: 1,
          title: ''
        }
      ],
      type: {},
      toType: '',
      canSubmit: false,
      t: '',
      socket: null,
      reStartNum: 0,
      downloadPercent: '0%',
      showDownload: false,
      showSelect: true,
      showNotice: false,
      peData: {},
      showNoticeDetail: false
    }
  },
  methods: {
    loadSct() {
      // 加载js文件
      if (window.WebSocket) {
        return new Promise((r, j) => {r(true)})
      }

      return this.load(websocketjs)
    },
    load(src, type) {
      return script.load(src, type)
    },
    async open(r, t, data) {
      console.log(data,window._XN_upCfg);
      this.r = r
      this.t = t
      this.peData = data;
      const types = await this.getData()
      this.matchTypes(types)
      this.show = true
      // this.toType = t
    },
    goPeMiddle() {
      const url = peMiddle;

      window.open(url, '', '', true);
    },
    matchTypes(types) {
      types.forEach((i, d) => {
        i.id = i.key
        this.types.forEach(j => {
          if (j.code == i.id) {
            this.$set(j, 'title', i.title)
          }
        })
      })

      // this.type = types[0]
    },
    checkFileType(f) {
      // 检查文件类型
      let type = ''
      // let ext = f.name.split('.').pop() || f.path.split('.').pop()

      let ext = f.split('.').pop()

      ext = ext.toLowerCase()

      if (this.peData.file_format.image.indexOf(ext) > -1) {
        type = 1
      } else if (this.peData.file_format.video.indexOf(ext) > -1) {
        type = 2
      } else if (this.peData.file_format.audio.indexOf(ext) > -1) {
        type = 3
      }

      return type
    },
    selectType(t) {
      this.type = t;
      this.showNoticeDetail = true;
      this.canSubmit = true;
    },
    close() {
      this.show = false;
      this.showSelect = true;
      this.showDownload = false;
      this.showNotice = false;
    },
    handleSocket() {
      this.loadSct()
        .then(() => {
          let url = 'ws://localhost:8181';
          const ws = new WebSocket(url);
          ws.onopen = () => {
            this.reStartNum = 0;
            this.showSelect = false;
            this.showNotice = false;
            this.showDownload = true;
            let loginData = {

            }

            if(this.peData.canEdit){
              loginData = {
                Type: 'startPE',
                Data: {
                  downloadUrl: this.peData.download_url,
                  original_path: window._XN_upCfg.httpPath,
                  filename_id: window._XN_upCfg.fileNameId,
                  pageId: this.peData.pageId,
                  pageType: this.peData.pageType,
                  idString: this.peData.idstring,
                  appId: this.peData.appId,
                  appSecret: this.peData.appSecret
                }
              }
            }else{
              loginData = {
                Type: 'startPE',
                Data: {
                  downloadUrl: this.peData.download_url,
                  original_path: window._XN_upCfg.httpPath,
                  filename_id: window._XN_upCfg.fileNameId,
                  pageId: null,
                  pageType: null,
                  idString: this.peData.idstring,
                  appId: this.peData.appId,
                  appSecret: this.peData.appSecret
                }
              }
            }

            //   let msg = {
            //     Data: {
            //       Title: '393cp-38a63e0f3ce2bcbf2b27e4055f436e21cb5998e6.mp3',
            //       uploadUrl: '/mnt/xnews20/original/2020/05/22/393cp-38a63e0f3ce2bcbf2b27e4055f436e21cb5998e6.mp3'
            //     }
            //   }

            //   const fileList = []
            //   const type = this.checkFileType(msg.Data.Title)
            //   const fileName = msg.Data.Title || ''
            //   const nameParts = fileName.split('.')
            //   const ext = nameParts.pop()
            //   let nameLeft = nameParts.join('.')
            //   nameLeft = nameLeft.substr(0, 40)
            //   const filetitle = `${nameLeft}.${ext}`

            //   const file = {
            //     type: type,
            //     title: filetitle,
            //     path: msg.Data.uploadUrl || '',
            //     subject_id: this.peData.pageId,
            //     subject_type: this.peData.pageType
            //   }

            //   fileList.push(file)

            //   const info = {file_info: JSON.stringify(fileList)}

            //   common.myFetch(apis.File_add, info)
            //   .then(r => {
            //     if (r) {
            //       console.log(r)
            //       // this.getFileAssets()
            //     }
            //   })
              
            // return false
            ws.send(JSON.stringify(loginData))
            console.log('sockek已连接')
          }

          ws.onclose = () => {
            console.log('socket链接关闭')
            if(this.show){
              if(this.reStartNum >= 3){
                this.showDownload = false;
                this.showNotice = false;
                this.showSelect = true;
                this.$toast('请先安装同步软件')
              }else{
                setTimeout(() => {
                  this.handleSocket()
                  this.reStartNum++
                }, 3000)
              }
            }
            // this.$toast('请先安装同步软件')
          }

          ws.onmessage = (r) => {

            let msg = JSON.parse(r.data)
            // console.log(msg)
            if(msg.Type === 'peDownload'){
              if(msg.Data.downloadStatus == 'true'){
                this.downloadPercent = msg.Data.Percent;
                if(msg.Data.Percent=='100%'){
                  this.showDownload = false
                  this.showSelect = false
                  this.showNotice = true
                }
              }
            }else if(msg.Type === 'peEditComplete'){
              // let msg = {
              //   Data: {
              //     Title: '393cp-8b9e60739a9076a3eb36f2b30410c44f62ec7cd6.s48',
              //     uploadUrl: '/mnt/xnews20/original/2020/05/22/393cp-8b9e60739a9076a3eb36f2b30410c44f62ec7cd6.s48'
              //   }
              // }
              const fileList = []
              const type = this.checkFileType(msg.Data.Title)
              const fileName = msg.Data.Title || ''
              const nameParts = fileName.split('.')
              const ext = nameParts.pop()
              let nameLeft = nameParts.join('.')
              nameLeft = nameLeft.substr(0, 40)
              const filetitle = `${nameLeft}.${ext}`

              let file = {}

              if(this.peData.pageId == null || this.peData.pageType == null){
                file = {
                  type: type,
                  title: filetitle,
                  path: msg.Data.uploadUrl || ''
                }
              }else{
                if(this.peData.canEdit){
                  file = {
                    type: type,
                    title: filetitle,
                    path: msg.Data.uploadUrl || '',
                    subject_id: this.peData.pageId,
                    subject_type: this.peData.pageType
                  }
                }else{
                  file = {
                    type: type,
                    title: filetitle,
                    path: msg.Data.uploadUrl || '',
                    subject_id: '',
                    subject_type: ''
                  }
                }
              }

              fileList.push(file)

              const info = {file_info: JSON.stringify(fileList)}

              common.myFetch(apis.File_add, info)
              .then(r => {
                if (r) {
                  // console.log(r)
                  // // this.getFileAssets()
                  this.close()
                  setTimeout(() => {
                    this.r('peComplete')
                  }, 50)
                }
              })

            }



            console.log('socket type', msg.Type)

          }

          ws.onerror = () => {
            console.log('socket连接错误')
          }

        })
    },
    confirm() {
      if(this.type.code==0&&this.t!=3){
        this.$toast('请先音频转文字')
      }else if(this.type.code==1){
        let a = document.createElement('a');
        let body = document.body;
        a.href = 'PEMiddle://';
        body.appendChild(a);
        a.click();
        body.removeChild(a);

        setTimeout(() => {
          this.handleSocket()
        },3000)
        
        // return false
      }else{
        this.close()
        setTimeout(() => {
          this.r(`${this.type.code}`)
        }, 50)
      }
    },
    cancel() {
      // this.r(false)
      this.close()
    },
    getData() {
      const info = {
        to_type: this.toType
      }
      return common.myFetch(apis.editaudioconfig, info)
      .then(r => {
        if (r) {
          return r.edit_config
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3222;
  }
  .wrapper {
    min-height: 290px;
    width: 490px;
    padding: 20px 30px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 99998;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    .headline {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 18px;
      p {
        font-size: 24px;
        color: @dark;
        font-weight: bold;
      }
      .close {
        // position: absolute;
        // right: 28px;
        // top: 18px;
        cursor: pointer;
      }
    }
    .types {
      display: flex;
      height: 130px;
      width: 100%;
      // padding: 0 50px;
      justify-content: space-around;
      .type {
        width: 130px;
        height: 130px;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px;
        .selector {
          width: 16px;
          height: 16px;
        }
        .con {
          width: 78px;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: @sub;
          img {
            margin-bottom: 12px;
          }
        }
      }
      .active {
        border-color: @green;
        .con {
          color: @green;
        }
      }
    }
    .notice-container {
        position: relative;
        width: 100%;
        height: 36px;
        margin: 20px 0 0;

      .smartEdit, .peEdit {
        position: absolute;
        top: 0;
        left: -30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 490px;
        height: 36px;
        background: #FFF4D0;
        border-top: 1px solid #F0C129;
        border-bottom: 1px solid #F0C129;
        padding: 0 30px;
        box-sizing: border-box; 

        div {
          display: flex;
          flex-direction: row;
          align-items: center;

          img {
            width: 15px;
            height: 14px;
            margin-right: 10px;
          }

          p {
            font-size: 14px;
            color: #E7B615;
          }

          a {
            color: @green;
            font-size: 14px;
          }
        }
      }
    }
    .btns {
      margin-top: 20px;
      height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;
    }
    .btn {
      width: 120px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background-color: @dateColor;
      border-radius: 25px;
      color: #FFF;
      font-size: 14px;
      box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      user-select: none;
      margin-right: 20px;

      &:nth-last-of-type(1) {
        margin-right: 0;
      }

      .green {
        background: @green
      }
    }
    .confirm, .cancel {
      background-color: @bg;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid @green;
      color: @green;
      font-size: 14px;
      box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 20px;
      color: #fff;
      background-color: @green;
    }
  }

  .download-container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 590px;
    height: 136px;
    padding: 20px 30px;
    border-radius: 4px;
    background: #F9F9F9;
    box-sizing: border-box;

    span {
      font-size: 20px;
      line-height: 20px;
      color: #050F0F;
    }

    img {
      position: absolute;
      top: 20px;
      right: 30px;
      cursor: pointer;
    }

    .line {
      position: relative;
      width: 100%;
      height: 3px;
      border-radius: 1.5px;
      background: rgba(151,151,151,0.3);
      margin-top: 32px;
      overflow: hidden;

      .green {
        position: absolute;
        top: 0;
        left: 0;
        width: 0%;
        height: 3px;
        border-radius: 1.5px;
        background: #41B48C;
      }
    }
  }

  .important-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 400px;
    height: 240px;
    border-radius: 4px;
    background: #F9F9F9;
    padding: 40px 0 62px;
    box-sizing: border-box;

    .importantIcon {
      width: 50px;
      height: 50px;
      margin-bottom: 30px;

      img {
        width: 50px;
        height: 50px;
      }
    }

    & > img {
      position: absolute;
      top: 20px;
      right: 30px;
    }

    p {
      font-size: 20px;
      line-height: 20px;
      color: #050F0F;
      margin-bottom: 14px;
    }

    span {
      font-size: 14px;
      line-height: 14px;
      color: #829191;
    }
  }
</style>
